import { postRequest } from 'utilities/service.utils';
import createUrlBuilder from 'utilities/url.builder.utils';
import AppService from './app.service.context';
import { amplifyGetCurrentSession } from './auth.service';

export const collectService = async (payload: any) => {
  let isAnonymous = true;
  try {
    const session = await amplifyGetCurrentSession();
    if (session) {
      isAnonymous = false;
    }
  } catch (e) {
    // do nothing
  }
  const urlBuilder = createUrlBuilder(
    `/track/collect${isAnonymous ? '/anonymous' : ''}`
  );
  return await postRequest(AppService, urlBuilder?.toString(), payload);
};
